import * as React from "react";
import { forwardRef } from "react";
const SvgHrManagement = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-users-round", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M18 21a8 8 0 0 0-16 0" }), /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 8, r: 5 }), /* @__PURE__ */ React.createElement("path", { d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" }));
const ForwardRef = forwardRef(SvgHrManagement);
export { ForwardRef as ReactComponent };
